<div class="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
  <div class="flex items-center justify-between h-16">
    <div class="flex items-center gap-4 cursor-pointer" routerLink="/dashboard/regional">
      <img class="h-9 w-auto" ngSrc="./assets/images/vepc-logo.png" priority alt="vepc-logo" height="123" width="372" />
      <div class="hidden xl:block border-l border-slate-200 pl-4">
        <nem-logo [width]="120"></nem-logo>
      </div>
    </div>

    <nav class="hidden lg:flex items-center space-x-2 ml-auto">
      @for (nav of navigation(); track nav.label) {
      <a
        [routerLink]="nav.routerLink"
        routerLinkActive="bg-indigo-50 text-indigo-700 font-semibold"
        [routerLinkActiveOptions]="{ exact: true }"
        [pTooltip]="nav.tooltip"
        tooltipPosition="bottom"
        class="px-3 py-2 rounded-lg text-sm font-medium text-slate-600 hover:text-indigo-600 hover:bg-slate-50 transition-colors">
        {{ nav.label }}
      </a>
      }

      <!-- <button
        (click)="themeService.toggleTheme()"
        class="ml-4 p-2 rounded-full text-slate-500 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-amber-400 transition-all duration-300 focus:outline-none">
        <i class="pi text-lg" [ngClass]="themeService.isDarkMode() ? 'pi-sun' : 'pi-moon'"></i>
      </button> -->

      @if (authenticated) {
      <div class="pl-4 ml-2 border-l border-slate-200">
        <button
          (click)="onSignOut()"
          class="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-slate-500 hover:text-rose-600 hover:bg-rose-50 transition-colors">
          <i class="pi pi-sign-out"></i>
          <span>Sign Out</span>
        </button>
      </div>
      }
    </nav>

    <div class="flex items-center lg:hidden ml-auto">
      <button
        (click)="sidebarVisible = true"
        class="p-2 -mr-2 text-slate-500 hover:text-indigo-600 transition-colors rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500/50">
        <i class="pi pi-bars text-2xl"></i>
      </button>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="sidebarVisible" position="right" styleClass="w-72 border-l border-slate-100 shadow-2xl">
  <ng-template pTemplate="header">
    <nem-logo [width]="120"></nem-logo>
  </ng-template>

  <nav class="mt-6 flex flex-col gap-1">
    @for (nav of navigation(); track nav.label) {
    <a
      [routerLink]="nav.routerLink"
      (click)="sidebarVisible = false"
      routerLinkActive="bg-indigo-50 text-indigo-700 border-r-4 border-indigo-600"
      [routerLinkActiveOptions]="{ exact: true }"
      class="px-4 py-3 text-sm font-medium text-slate-600 hover:bg-slate-50 hover:text-indigo-600 transition-all rounded-l-lg">
      {{ nav.label }}
    </a>
    } @if (authenticated) {
    <div class="mt-6 pt-6 border-t border-slate-100">
      <button
        (click)="onSignOut(); sidebarVisible = false"
        class="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-slate-500 hover:bg-rose-50 hover:text-rose-600 transition-all rounded-lg">
        <i class="pi pi-sign-out text-lg"></i>
        <span>Sign Out</span>
      </button>
    </div>
    }
  </nav>
</p-sidebar>
